import { When } from 'react-if';
import { useTranslation } from 'next-i18next';
import { Radio, Tooltip } from '@zep/ui';
import { QuestionmarkSmallCircleColorIcon } from '../../../../icons';
import { useSubscriptionPaymentContext } from '../hooks';
import S from '../PaymentPeriodRadio.module.scss';
export const PaymentPeriodRadio = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    spacePlanProducts,
    handlePaymentPeriod,
    subscriptionPeriod,
    subscription
  } = useSubscriptionPaymentContext();
  return (
    // 수동 정기인 경우에 해당 UI 제거
    <When condition={Object.keys(spacePlanProducts).length !== 1} data-sentry-element="When" data-sentry-component="PaymentPeriodRadio" data-sentry-source-file="PaymentPeriodRadio.tsx">
      <div className={S.radio_group}>
        <div className="flex items-center gap-4xs">
          <Radio label={t('subscription:pricing.selectPlan.monthlyPayment')} labelPlacement={'left'} disabled={subscription?.saleType === 'annuallyPayment'} onChange={() => handlePaymentPeriod(30)} checked={subscriptionPeriod === 30 && subscription?.saleType !== 'annuallyPayment'} data-sentry-element="Radio" data-sentry-source-file="PaymentPeriodRadio.tsx" />
          {subscription?.saleType === 'annuallyPayment' && <Tooltip title={t('subscription:payment.planRadio.tooltipTitle')} placement={'bottom-start'}>
              <QuestionmarkSmallCircleColorIcon width={24} height={24} />
            </Tooltip>}
        </div>
        <Radio label={<span>
              {t('subscription:pricing.selectPlan.annuallyPayment')}
              {/*에듀의 경우 연간결제의 할인율(saleType === 'annuallyPayment')을 받아올 수 없어서 static하게 고정 - 당분간 바뀔 일 거의 없음*/}
              <span className={S.discount_chip}>16%</span>
            </span>} labelPlacement={'left'} onChange={() => handlePaymentPeriod(365)} checked={subscriptionPeriod === 365 || subscription?.saleType === 'annuallyPayment'} data-sentry-element="Radio" data-sentry-source-file="PaymentPeriodRadio.tsx" />
      </div>
    </When>
  );
};